import { colors } from "theme/palette";

import Box from "components/Box";
import Stack from "components/Stack";
import Text from "components/Text";

import SectionContent from "entities/Memo/components/Sections/SectionContent";
import SectionHeader from "entities/Memo/components/Sections/SectionHeader";
import { ISignatureCustomField } from "entities/MemoTemplate/sdk";

export interface IMemoTemplateSignatureSection {
  title: string;
  customFields?: Array<ISignatureCustomField>;
}

const MemoTemplateSignatureSection = ({
  title,
  customFields,
}: IMemoTemplateSignatureSection) => (
  <Box>
    <SectionHeader label={title} />
    <SectionContent>
      <Stack direction="row" gap={5}>
        <Box border={1} width="35%" height="80px" />
        <Stack direction="column" gap={4}>
          {customFields?.map((customField, index) => (
            <Text variant="text3" color={colors.gray80} key={index}>
              {customField.name}
            </Text>
          ))}
        </Stack>
      </Stack>
    </SectionContent>
  </Box>
);

export default MemoTemplateSignatureSection;
